<template>
  <div class="comment-list" :class="isFromMiniProgram ? 'mini-program' : ''">
    <div class="desc">
      评论({{count}})
    </div>
    <div class="list" v-show="!isShowNo">
      <ul>
        <li v-for='item in commentList'>
          <a class="item Fix">
            <div class="pic">
              <a :href="getUserHref(item.userId)"  class="display:inline-block;width: 100%;height:100%">
                <img :src="item.userPic" alt="">
              </a>
            </div>
            <div class="content">
              <div class="name">
                  <a :href="getUserHref(item.userId)">
                    <span class="user_name">
                        {{item.userName}}
                    </span>
                  </a>
                  <span class="time">
                    {{item.time}}
                  </span>
              </div>
              <div class="comment">
                <span>{{item.reviewBody}}</span>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <div class="more-list" v-show="isShowMore">
        <a class="btn-more" @click="getMoreComment">
          查看更多评论
          <i></i>
        </a>
      </div>
    </div>
    <div class="no-comment"  v-show="isShowNo">
      <a v-if="isFromMiniProgram">
        <div class="content">
          <i></i>
        </div>
      </a>
      <a v-else :href="detailHref">
        <div class="content">
          <i></i>
          <p class="p-desc">看视频，抢沙发！</p>
          <p class="p-btn">添加第一条评论</p>
        </div>
      </a>
    </div>
    <a v-if="!isFromMiniProgram" :href="detailHref" class="forward">
      <div class="add-comment">
          <div class="msg"><span>hi,留下你的留言吧</span></div>
          <div class="num">
            <div class="comment">
              <i class="icon"></i>
              <span>{{count}}</span></div>
            <div class="flower" :class="{ isSendFlower: isSendFlower }">
              <i class="icon"></i>
              <span>{{flowerNum}}</span></div>
          </div>
      </div>
    </a>
  </div>
</template>
<script>
  import Util from '../libs/util'
  import fetchData from '../libs/fetchData'
  export default {
    name: 'commentList',
    data () {
      return {
        commentList: [],
        commentNum: 0,
        flowerNum: 0,
        isShowMore: false,
        count: 0,
        page: 1,
        pageSize: 10,
        remainList: [],
        isShowNo: true,
        videoId: 0,
        pageCount: 0,
        isSendFlower: false
      }
    },
    props: ['detailHref', 'isFromMiniProgram'],
    created (){
      this.loadData()
    },
    methods: {
      loadData(){
        let vm = this
        let videoId = Util.getQueryString('videoId')
        if(videoId){
          vm.videoId = videoId
          vm.getNum(vm.videoId)
          vm.getComment(vm.videoId)
        }
      },
      getNum(videoId) {
        let vm = this
        fetchData.getdata({
          urlname: 'getFooterNum',
          data: {
            videoId: videoId
          }
        }).then((data) => {
          let numData = data.data
          if(numData){
            vm.commentNum = numData.commentCount
            vm.flowerNum = numData.flowerCount
            vm.isSendFlower = numData.isSendFlower
          }
        })
      },
      getComment(videoId){
        let vm = this
        fetchData.getdata({
          urlname: 'getComment',
          data: {
            videoId: videoId,
            page: vm.page,
            pageSize: vm.pageSize
          }
        }).then((data) => {
          let commentData = data.data
          if(commentData) {
            vm.count = commentData.recordCount || 0
            if (vm.count && vm.page == 1) {
              vm.isShowNo = false
              let mod = Math.ceil(vm.count / 10)
              vm.pageCount = mod + 1
              vm.page = commentData.page
            }else{
              vm.page = commentData.page + 1
            }
            if (vm.page == vm.pageCount) {
                commentData.records.forEach((item,key) => {
                  vm.commentList.push(item)
                })
                vm.isShowMore = false
            }else if(vm.page < vm.pageCount){
                commentData.records.forEach((item, key) => {
                    vm.commentList.push(item)
                })
            }
            if (vm.page === 1) {
              vm.count = commentData.recordCount
              if (vm.count < 4 && vm.page == 1) {
                vm.isShowMore = false
                vm.commentList = commentData.records
              } else if (vm.count > 3 && vm.page == 1) {
                vm.isShowMore = true
                vm.commentList = commentData.records.slice(0, 3)
                vm.remainList = commentData.records.slice(3)
              }
            }
          }
        })
      },
      getUserHref(userId){
        if (this.isFromMiniProgram) {
          return
        } else {
          return fetchData.getHref('authorHref',userId)
        }        
      },
      getMoreComment(){
          let vm = this
          vm.page = vm.page + 1
          if(vm.page == 2 && vm.remainList.length > 0){
              vm.remainList.forEach((item, key) => {
                vm.commentList.push(item)
              })
              vm.remainList = []
              if(vm.pageCount == vm.page){
                  vm.isShowMore = false
              }
          }else{
              vm.page = vm.page - 1
              vm.getComment(vm.videoId)
          }
      }

    }
  }
</script>



// WEBPACK FOOTER //
// comment.vue?6c652cea